export default __webpack_public_path__ + "static/media/roboto-slab-latin-wght-normal.dc326069.woff2";